import { render, staticRenderFns } from "./learning-progress.vue?vue&type=template&id=0137954a&"
import script from "./learning-progress.vue?vue&type=script&lang=js&"
export * from "./learning-progress.vue?vue&type=script&lang=js&"
import style0 from "./learning-progress.vue?vue&type=style&index=0&id=0137954a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports